import { captureException as sentryCaptureException, captureMessage as sentryCaptureMessage } from '@sentry/browser';
export const SENTRY_ALERT_TAG = 'reporting';

/**
 * Add `reporting` tag to the event, which will trigger an alert in Sentry
 *
 * @type {typeof sentryCaptureException}
 */
export const captureException = (err, options = {}) => {
  return sentryCaptureException(err, {
    ...options,
    tags: {
      [SENTRY_ALERT_TAG]: true,
      ...options?.tags
    }
  });
};

/**
 * Captures an error boundary exception in a similar way that @sentry/react does
 *
 * @type {typeof captureException}
 */
export const captureErrorBoundaryException = (err, errorInfo) => {
  return captureException(err, {
    captureContext: {
      contexts: {
        react: {
          componentStack: errorInfo?.componentStack
        }
      }
    }
  });
};

/**
 * Add `reporting` tag to the event, which will trigger an alert in Sentry
 *
 * @type {typeof sentryCaptureMessage}
 */
export const captureMessage = (message, options = {}) => {
  return sentryCaptureMessage(message, {
    ...options,
    tags: {
      [SENTRY_ALERT_TAG]: true,
      ...options?.tags
    }
  });
};
//# sourceMappingURL=utils.js.map